import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            boxItemsOptions: [],
            boxPathResource: "/agendebox",
        };
    },
    methods: {
        boxLoadData(afterLoadBox = null) {
            let me = this;
            let idAmbulatorio = sessionStorage.getItem("idAmbulatorio");
            let link = process.env.VUE_APP_PATH_API + me.boxPathResource;
            this.openShowModalLoading();
            axios.get(link, { params: {idAmbulatorio: idAmbulatorio} })
                .then((response) => {
                    this.boxItemsOptions = response.data.data.list;
                    this.closeShowModalLoading();
                })
                .catch((error) => {
                    this.$bvToast.toast("Errore nel recupero dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                    this.closeShowModalLoading();
                });
                if(afterLoadBox!== null){
                    afterLoadBox();
                }
        }
    },
};
